import { forwardRef, useCallback, useMemo } from "react";
import { isWeb } from "@tamagui/core";
import { Linking } from "react-native-web";
import { ComponentWithViewTracking } from "../../helpers/analytics";
import { useObservabilitySafe } from "../../helpers/useObservabilitySafe";
import { jsx } from "react/jsx-runtime";
const useAnchorOrButtonPress = ({
  openURL,
  analyticsName,
  href,
  onPress
}) => {
  const handleURLNative = useMemo(() => {
    if (!isWeb)
      return openURL || (async (href2) => {
        if (!await Linking.canOpenURL(href2))
          throw new Error(`Cannot open URL: ${href2}`);
        return Linking.openURL(href2);
      });
  }, [openURL]), { trackJourneyEvent } = useObservabilitySafe();
  return useCallback(
    (e) => {
      analyticsName && trackJourneyEvent("platform", href ? "linkClickEvent" : "buttonClickEvent", { targetName: analyticsName }), href && handleURLNative && handleURLNative(href), onPress?.(e);
    },
    [analyticsName, href, handleURLNative, onPress, trackJourneyEvent]
  );
}, createAnchorOrButtonFrame = ({
  AnchorFrame,
  ButtonFrame
}) => forwardRef(function({ href, openURL, analyticsName, trackImpression, onPress, ...props }, ref) {
  const handlePress = useAnchorOrButtonPress({ href, openURL, analyticsName, onPress }), Component = isWeb && href ? /* @__PURE__ */ jsx(AnchorFrame, { href, onPress: handlePress, ref, ...props }) : /* @__PURE__ */ jsx(ButtonFrame, { onPress: handlePress, ref, ...props });
  return analyticsName && trackImpression ? /* @__PURE__ */ jsx(
    ComponentWithViewTracking,
    {
      Component,
      analyticsName,
      eventName: href ? "linkViewEvent" : "buttonViewEvent",
      ref
    }
  ) : Component;
});
export {
  createAnchorOrButtonFrame,
  useAnchorOrButtonPress
};
